module.exports = __webpack_public_path__ + "static/media/server_cloud.7d8664ae.svg";